var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStress5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156 156",
    style: {
      enableBackground: "new 0 0 156 156"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.8,1.1c5.8,0,10.5,4.7,10.5,10.5v132c0,5.8-4.7,10.5-10.5,10.5h-132c-5.8,0-10.5-4.7-10.5-10.5v-132 C1.3,5.8,6,1.1,11.8,1.1H143.8 M143.8-0.4h-132c-6.6,0-12,5.4-12,12v132c0,6.6,5.4,12,12,12h132c6.6,0,12-5.4,12-12v-132 C155.8,5,150.4-0.4,143.8-0.4L143.8-0.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78,146.5c-37.8,0-68.5-30.7-68.5-68.5C9.5,40.2,40.2,9.5,78,9.5s68.5,30.7,68.5,68.5C146.5,115.8,115.8,146.5,78,146.5z  M78,14.3c-35.1,0-63.7,28.6-63.7,63.7c0,35.1,28.6,63.7,63.7,63.7c35.1,0,63.7-28.6,63.7-63.7C141.7,42.9,113.1,14.3,78,14.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 78.4,
    cy: 116,
    rx: 26,
    ry: 5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.3,62.6c2.2,2.5,4.4,5.1,6.6,7.6c0.2-0.8,0.4-1.7,0.7-2.5c-3.3,1.1-6,3.2-8,6c-0.5,0.7-0.1,1.7,0.5,2.1 c0.8,0.4,1.6,0.1,2.1-0.5c1.5-2.1,3.7-3.8,6.2-4.6c1.1-0.4,1.4-1.6,0.7-2.5c-2.2-2.5-4.4-5.1-6.6-7.6c-0.5-0.6-1.6-0.5-2.1,0 C56.7,61,56.8,61.9,57.3,62.6L57.3,62.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M101.4,60.4c-2.2,2.5-4.4,5.1-6.6,7.6c-0.8,0.9-0.5,2.1,0.7,2.5c2.5,0.8,4.7,2.5,6.2,4.6c0.5,0.7,1.3,1,2.1,0.5 c0.6-0.4,1-1.4,0.5-2.1c-2-2.8-4.7-4.9-8-6c0.2,0.8,0.4,1.7,0.7,2.5c2.2-2.5,4.4-5.1,6.6-7.6c0.5-0.6,0.6-1.5,0-2.1 C103,59.9,101.9,59.8,101.4,60.4L101.4,60.4z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStress5);
export default __webpack_public_path__ + "static/media/Stress5.1e6e3df17f2cb56e8f27b203474390f2.svg";
export { ForwardRef as ReactComponent };